import type React from 'react';
import { FormattedMessage } from 'react-intl';

import { GridItem } from '@xing-com/grid';

import ImageWithMessageIllustration1 from '../../assets/image-with-message-illustration-1.png';
import ImageWithMessageIllustration2 from '../../assets/image-with-message-illustration-2.png';
import { translationVariables } from '../../constants';

import {
  FirstImage,
  SecondImage,
  ImagesWrapper,
  StyledHero,
  StyledGridContainer,
} from './images-with-message.styles';

export const ImagesWithMessage: React.FC = () => {
  return (
    <StyledGridContainer variant="FullSize">
      <GridItem span={12}>
        <ImagesWrapper>
          <FirstImage src={ImageWithMessageIllustration1} alt="" />
          <SecondImage src={ImageWithMessageIllustration2} alt="" />
          <StyledHero forwardedAs="h3" size="small" sizeConfined="medium">
            <FormattedMessage
              id="UPSELL_LOGGED_OUT_PAGE_IMAGES_TEXT"
              values={
                translationVariables['UPSELL_LOGGED_OUT_PAGE_IMAGES_TEXT']
                  .values
              }
            />
          </StyledHero>
        </ImagesWrapper>
      </GridItem>
    </StyledGridContainer>
  );
};
